<template>
	<div class="questionnaire">
		<el-drawer size="800px" :show-close="false" :visible="visible" :before-close="closeDlg">
			<template slot="title">
				<div class="el-drawer-close" @click="closeDlg"><i class="el-icon el-icon-arrow-left"></i>返回</div>
				选择{{showType?'评估单':'问卷'}}
			</template>
			<div class="questionnaire_c">
				<div class="search-bar">
					<label>{{showType?'评估单':'问卷'}}名称
						<el-input size="small" v-if="showType" placeholder="评估单名称" clearable v-model="filter.name"
							@keyup.enter.native="changeFilter(0)" @clear="changeFilter(0)"></el-input>
							<el-input size="small" v-else placeholder="问卷名称" clearable v-model="filter.name"
							@keyup.enter.native="changeFilter(0)" @clear="changeFilter(0)"></el-input>
					</label>
					<div style="display: inline-block;" v-if="!showType">科室
						<el-select size="small" class="multiple-select" filterable multiple clearable collapse-tags v-model="filter.depId" placeholder="请选择" @change="changeFilter(1, $event)">
							<el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</div>
					<el-button size="mini" icon="el-icon-search" round @click="changeFilter(0)">搜索</el-button>
				</div>
				<el-table class="table_q" ref="multipleTable" header-cell-class-name="tab-cell"
					cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading"
					@selection-change="selectionChange">
					<el-table-column prop="name" v-if="showType" label="评估单名称" align="center"></el-table-column>
					<el-table-column prop="name" v-else label="问卷名称" align="center"></el-table-column>
					<el-table-column label="所属科室"  v-if="!showType"  show-overflow-tooltip  align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.allDepartment==1">所有科室</span>
							<span v-else v-text="scope.row.depList?.map(item=>item.depName).join(', ')"></span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" width="120">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="填写" placement="top" :enterable="false">
									<!-- <router-link :to="{path:'/q-detail-1',query:{id:1,name:'vue'}}" target="_blank">
										<i class="icon-edit" @click="onView(scope.row)" style="color: #699CE4;"></i>
									</router-link> -->
									<i class="icon-edit" @click="onView(scope.row.id)" style="color: #699CE4;"></i>
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import api from '@/service/api.js';
	export default {
		props: {
			visible: Boolean,
			recordId:Number,
			recordType:Number,
			patientId:Number,
			customerId:Number,
			writeQuestionnaire:{
				require:true
			},
			showType:String,
		},
		data() {
			return {
				isLoading: false,
				list: {
					current: 1,
					total: 0,
					pageSize: 0,
					data: null
				},
				filter: {
					type: 0,
					code: null,
					questionnaireJson: null,
					remark: null,
					subtype: null,
					name: null,
					pageNumber: 1,
					pageSize: 10,
					depIds:''
				},
				my: undefined,// 当前登录用户信息
				deptList: [],
				depFilter:{
					departmentState:'',
					departmentType:'',
					id:'',
					name:'',
					orgId:'',
					pageNumber:1,
					pageSize:9999
				},
			}
		},
		created() {
			this.init();
		},
		methods: {
			
			async init() {
				this.my = JSON.parse(localStorage.getItem('user')).data;
				this.loadList();
				api.getListComboboxDep(this.depFilter).then((res)=>{
					if (res.code == 1000 && res.data) {
						this.deptList = res.data;
					}
				});
			},
			async loadList() {
				this.isLoading = true;
				if(this.recordType==4){
					this.filter.type=4;
				}
				if (this.filter.depId) {
					this.filter.depIds = this.filter.depId.join(',');
				}
				let res = await api.getQuestiondictList(this.filter);
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}
				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				if (res.data) {
					this.list.data = res.data;
				}
				this.isLoading = false;
			},
			closeDlg() {
				this.$emit('close');
				if(this.filter.depId.length>0){
					this.filter.depId=[];
					this.loadList();
				}
				this.filter.depId=[];
			},
			async onView(id) {
				let res = await api.getQuestiondictById(id);
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}
				if (res.code == 1000) {
					let opt = {
						"customerId": this.customerId||0,
						"patientId": this.patientId,
						"qcId": res.data.id,
						"recordId": this.recordId,
						"recordType":this.recordType
					}
					let res1 = await api.questionresultAdd(opt);
					if (res1.code == 1000) {
						let data1 = res1.data;
						let questionnaireJson = JSON.parse(res.data.questionnaireJson);
						const href = this.$router.resolve({
							path: '/qst/' + res1.data.qcId,
							query: {
								rid:res1.data.id,
								t:this.my.token,
							}
						})
						window.open(href.href, "_blank");
					}else{
						this.$message.info(res1.message);
					}
					this.$emit('update:writeQuestionnaire', true)
				}
			},
			selectionChange() {

			},
			handleSizeChange(v) {
				this.filter.pageSize = v;
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleCurrentChange(v) {
				this.filter.pageNumber = v;
				this.loadList();
			},
			// 过滤条件 更改
			changeFilter() {
				this.loadList();
			},
		}
	}
</script>

<style lang="less" scoped>
.search-bar {
    padding: 20px 10px 10px !important;
}
.multiple-select{
			margin-left: 10px;
			margin-right: 30px;
			/deep/ .el-input{
				width: 250px;
				margin:0;
			}
		}
	/deep/ .questionnaire_c {
		padding: 30px;

		th {
			background-color: #699CE4;
			color: #FFFFFF;
		}
	}
</style>
